import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    body {
        font-family: "Gilroy", Arial, sans-serif !important;
    }
    * {
        cursor: pointer;
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }
`;

export const ShuttleAppName = styled.div({
    display: "none",
});
